import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { EColType, ICol } from '@bixi/core/table';
import { IMFileBase } from '@mining/ui/core/types';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'm-upload-file-list',
  exportAs: 'mUploadFileList',
  template: `
    <div *ngIf="mFileList.length" class="m-upload-list">
      <bixi-table tableLayout="fixed" [rows]="mFileList" [cols]="cols"></bixi-table>
    </div>
    <div *ngIf="mFileList.length" class="m-upload-list-footer">
      <ng-container [ngTemplateOutlet]="mFooterRef"></ng-container>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MUploadFileListComponent {
  @Input() mFileList: NzUploadFile[] = [];
  @Input() mFooterRef!: TemplateRef<void>;
  @Output() readonly mFileListChange = new EventEmitter<NzUploadFile[]>();

  constructor(protected msg: NzMessageService) {}

  cols: ICol[] = [
    {
      name: '文件名称',
      key: 'name',
      ellipsis: true,
      width: '65%'
    },
    {
      name: '大小',
      key: 'sizeValue',
      width: '150px'
    },
    {
      name: '操作',
      key: 'action',
      width: '100px',
      type: EColType.operations,
      operations: () => {
        return [
          {
            name: '删除',
            onClick: (item: IMFileBase) => {
              this.deleteFileItem(item);
            }
          }
        ];
      }
    }
  ];

  deleteFileItem(item: NzUploadFile): void {
    this.mFileList = this.mFileList.filter(ele => ele.uid !== item.uid);
    this.mFileListChange.emit(this.mFileList);
  }
}
